import { render, staticRenderFns } from "./destroy.vue?vue&type=template&id=98d82098"
import script from "./destroy.vue?vue&type=script&lang=ts"
export * from "./destroy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports